import React, { useState } from 'react';
import { Button, Form, Spinner, Alert } from 'react-bootstrap';
import { patch } from '../../../helpers/httpClient';
import { toast } from 'react-toastify';

// General tab module: expects full website object
function General({ website, onUpdated }) {
  const hasWebsite = !!website;
  const [edit, setEdit] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState({
    internal_domain: (website && website.internal_domain) || '',
    title: (website && website.title) || '',
    domain: (website && website.domain) || ''
  });

  const startEdit = () => {
    setForm({
      internal_domain: website.internal_domain || '',
      title: website.title || '',
      domain: website.domain || ''
    });
    setError('');
    setEdit(true);
  };

  const cancelEdit = () => {
    setError('');
    setEdit(false);
  };

  const save = async (e) => {
    e.preventDefault();
    if (!form.internal_domain.trim() || !form.title.trim()) {
      toast.error('Internal domain and title are required');
      return;
    }
    try {
      setSaving(true);
      setError('');
      const resp = await patch(`websites/${website.id}`, form);
      const updated = resp?.website || resp || { ...website, ...form };
      onUpdated?.(updated);
      setEdit(false);
    } catch (e) {
      toast.error('Failed to save changes.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      {!hasWebsite ? (
        <Alert variant="warning">Website not found.</Alert>
      ) : !edit ? (
        <>
          <p style={{ marginBottom: '0.75rem', color: '#64748b' }}>Overview of the website settings.</p>
          <ul style={{ marginBottom: 0 }}>
            <li><strong>Internal domain:</strong> {website.internal_domain || '-'}</li>
            <li><strong>Title:</strong> {website.title || '-'}</li>
            <li><strong>Domain:</strong> {website.domain || '-'}</li>
            {website.id && <li><strong>ID:</strong> {website.id}</li>}
          </ul>
          <div style={{ marginTop: '12px' }}>
            <Button className="login-button" size="sm" onClick={startEdit}>Edit</Button>
          </div>
        </>
      ) : (
        <>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form onSubmit={save}>
            <Form.Group className="mb-3 form-row-horizontal" controlId="editInternalDomain">
              <Form.Label>Internal domain</Form.Label>
              <Form.Control
                type="text"
                value={form.internal_domain}
                onChange={(e) => setForm({ ...form, internal_domain: e.target.value })}
                placeholder="e.g. project-123"
              />
            </Form.Group>
            <Form.Group className="mb-3 form-row-horizontal" controlId="editTitle">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                value={form.title}
                onChange={(e) => setForm({ ...form, title: e.target.value })}
                placeholder="Marketing site"
              />
            </Form.Group>
            <Form.Group className="mb-3 form-row-horizontal" controlId="editDomain">
              <Form.Label>Domain</Form.Label>
              <Form.Control
                type="text"
                value={form.domain}
                onChange={(e) => setForm({ ...form, domain: e.target.value })}
                placeholder="Optional: www.example.com"
              />
            </Form.Group>
            <div style={{ display: 'flex', gap: 8 }}>
              <Button type="submit" className="primary-button" disabled={saving}>
                {saving ? (<><Spinner animation="border" size="sm" className="me-2" /> Saving...</>) : 'Save'}
              </Button>
              <Button className="primary-button" onClick={cancelEdit} disabled={saving}>Cancel</Button>
            </div>
          </Form>
        </>
      )}
    </div>
  );
}

export default General;
